import React, { useEffect, useState } from 'react';
const TOTAL_SECONDS = 17 * 60 + 34;
type CountdownProps = {
  tone?: 'light' | 'dark';
};
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function Countdown({
  tone = 'light'
}: CountdownProps) {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const isDark = tone === 'dark';
  const boxClass = isDark ? 'bg-white/10 text-white ring-1 ring-white/20' : 'bg-navy text-white';
  const labelClass = isDark ? 'text-white/60' : 'text-navy/50';
  const units: Array<[string, number]> = [['ORE', hours], ['MIN', minutes], ['SEC', seconds]];
  return <div className="flex flex-col items-center gap-2" data-id="element-19" data-mp="y16il3eljtnj">
      <p className={`text-[11px] font-bold uppercase tracking-[0.18em] ${labelClass}`} data-id="element-20" data-mp="xzlrxovekuuy">
        Questa offerta scade tra
      </p>
      <div className="flex items-center gap-1.5" role="timer" aria-live="off" aria-label={`Offerta valida per ${minutes} minuti e ${seconds} secondi`} data-id="element-21" data-mp="t092cwd5d9oo">
        {units.map(([label, value], index) => <React.Fragment key={label} data-id="element-22" data-mp="f3di07rg3vtb" data-mpi={index}>
            <div className={`flex min-w-[58px] flex-col items-center rounded-xl px-2.5 py-2 ${boxClass}`} data-id="element-23" data-mp="f4etgdcdikbk">
              <span className="font-display text-2xl font-bold leading-none tabular-nums sm:text-3xl" data-id="element-24" data-mp="a5kddj5sj9v5">
                {pad(value)}
              </span>
              <span className="mt-1 text-[9px] font-semibold uppercase tracking-[0.14em] opacity-60" data-id="element-25" data-mp="k0c90hftbmna">
                {label}
              </span>
            </div>
            {index < units.length - 1 && <span className={`font-display text-xl font-bold ${isDark ? 'text-white/40' : 'text-navy/30'}`} data-id="element-26" data-mp="1vfsltoobvugl">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}